import {tr} from "@vue-components/helpers/I18nPluginHelper.js";
import MapBaseClass from "./MapBaseClass.js";

const IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === `MacIntel` && navigator.maxTouchPoints > 1);

export default class MapFloor extends MapBaseClass {
    constructor(data) {
        super(data);

        if (this.level === undefined && this.floor !== undefined) {
            this.level = this.floor;
        }

        if (this.elevatorLabel === undefined) {
            this.elevatorLabel = null;
        }

        if (this.altitude && typeof this.altitude === `object`) {
            this.altitude = IS_IOS ? this.altitude.ios ?? this.altitude.android : this.altitude.android ?? this.altitude.ios;
        }

        // Version the floor plan URL (same convention as FileLibraryHelper.getCacheUrl) so the
        // service worker cacheFirst image cache picks up re-uploaded floor plans immediately
        if (this.imagePath && typeof this.imagePath === `string` && this.imageVersion > 0 && this.imagePath.indexOf(`rv=`) === -1) {
            this.imagePath += (this.imagePath.indexOf(`?`) >= 0 ? `&` : `?`) + `rv=${this.imageVersion}`;
        }
    }

    getName() {
        if (tr(this.label)) {
            return tr(this.label);
        } else {
            return tr(this.name);
        }
    }

    getNameWithOffset(itemFloorsSettings) {
        if (itemFloorsSettings?.multiple) {
            if (itemFloorsSettings.list.hasOwnProperty(this.id) && tr(itemFloorsSettings.list[this.id].name)) {
                return tr(itemFloorsSettings.list[this.id].name);
            }
        }
        return this.getName();
    }

    getElevatorLabel(itemFloorsSettings) {
        if (itemFloorsSettings?.multiple) {
            if (itemFloorsSettings.list.hasOwnProperty(this.id) && itemFloorsSettings.list[this.id].elevatorLabel) {
                return itemFloorsSettings.list[this.id].elevatorLabel;
            }
        }

        if (itemFloorsSettings?.levelOffset) {
            return this.level - itemFloorsSettings.levelOffset;
        }

        return this.elevatorLabel !== null ? this.elevatorLabel : this.level;
    }
}
